export const ALL_PRODUCTS_CATEGORY_NAME = 'All Products'
export const ALL_PRODUCTS_CATEGORY_ID = 'all-products'
